<template>
  <div class="main-cont container">
    <div v-if="avatarClicked" class="popup">
      <!-- <div v-if="avatarClicked"  class="img-popup">
        <a @click="avatarClick()" class="exit">X</a>
        <div  class="avtr-div inside">
          <img  v-if="this.getUser.img_url.length > 6" :src="this.getUser.img_url" class="avatar" />
        </div>
        <form style="text-align: center" method="POST" enctype="multipart/form-data">
          <input ref="image" accept="image/*" id="file" type="file" @change="imageSelected" name="file" />
          <a style="display: inline-block; text-align: center" class="gc-button" @click="uploadPhoto()" type="submit"> Upload </a>
        </form>
          <div class="avtr-info">
            <p>Acceptable formats</p>
            <p>.jpg and .png only</p>
            <p>Max file size 300kb</p>
          </div>            
          <div class=""> </div>
            <label style="display: block" class="avtr-info" for="url">Enter an https:// URL:</label>
            <input
              v-model="img_url"
              class="rt-cl"
              type="url"
              name="url"
              id="url"
              :placeholder="getUser['img_url']"
              pattern="https://.*"
            /><br />
            <button @click="handleUpdateForm()" class="gc-button avtr-btn">Submit</button>
      </div> -->
    </div>
    <h4 class="title">Account Information</h4>
        <!-- <div class="block">
              <h4>Images</h4>
              <div v-if="this.images.length == 0">
                <div @click="imgInputFocus()" class="img-div img-empty">
                  <a style="color: #9198aa" class="plus">+</a>
                </div>
              </div>
              <div v-if="this.images.length > 0">
                <div v-for="(img, index) in images" 
                  :key="index" 
                  class="img-div img-not-empty"
                    :style="{backgroundImage: 'url(' + img + ')'}"
                  >
                  <a @click="spliceImg(index)" class="cross">X</a>
                </div>
              </div>
              <div class="images">
                <input type="text" 
                  id="imgInput"
                  ref="imgInput"
                  v-model="imgUrl"
                  style="display: inline-block; width: 80%"
                  class="form-control url-input" 
                  placeholder="Paste URL"
                  >
                  <a @click="addImg(imgUrl)" style="display: inline-block; margin-left: 15px;" class="gc-button"><li>ADD</li></a>
              </div>
            </div> -->
    <section style="text-align: left;" id="avtr-sc">
      <form  v-on:submit.prevent="handleUpdateForm">
        <div class="block">
          <!-- <div style="border-radius: 15px" :style="{backgroundImage: 'url(' + this.getUser.img_url + ')'}" class="avtr-div">
            <div @click="avatarClick()" class="hover-div">
            </div>
          </div> -->
          <div class="row">
          <div class="col-sm-3 lt-cl">
            <label :for="email">Email:</label>
          </div>
          <div class="col-sm-3">
            <input
              v-model="email"
              v-if="edit"
              :placeholder="getUser['email']"
              class="form-control-2"
            />
            <span v-if="!edit" class="info-field">{{ getUser["email"] }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3 lt-cl">
            <label :for="username">Username:</label>
          </div>
          <div class="col-sm-3">
            <input
              v-model="username"
              v-if="edit"
              :placeholder="getUser['username']"
              class="form-control-2"
            />
            <span v-if="!edit" class="info-field">{{
              getUser["username"]
            }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3 lt-cl">
            <label :for="first_name">First Name:</label>
          </div>
          <div class="col-sm-3">
            <input
              v-model="first_name"
              v-if="edit"
              :placeholder="getUser['first_name']"
              class="form-control-2"
            />
            <span v-if="!edit" class="info-field">{{
              getUser["first_name"]
            }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3 lt-cl">
            <label :for="last_name">Last Name:</label>
          </div>
          <div class="col-sm-3">
            <input
              v-model="last_name"
              v-if="edit"
              :placeholder="getUser['last_name']"
              class="form-control-2"
            />
            <span v-if="!edit" class="info-field">{{
              getUser["last_name"]
            }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3 lt-cl">
            <label for="name">Password:</label>
          </div>
          <div class="col-sm-3 pwd-txt">
            <a href="#"> Change Password </a>
          </div>
        </div>        <br />
            <div class="edit-btn">
              <button
                v-if="edit"
                @click="setEdit(), handleUpdateForm()"
                class="gc-button btn-deact"
              >
                Save Changes
              </button>
              <button v-if="!edit" @click="setEdit()" class="gc-button btn-save">
                Edit
              </button>
            </div>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {SERVER_PATH} from '../../config'
import store from "../../store";
import axios from 'axios'
export default {
  name: "Profile",
  data() {
    return {
      url: '',
      photo: '',
      photoName: '',
      photoId: 0,
      avatarClicked: false,
      data: {},
      email: "",
      username: "",
      first_name: "",
      last_name: "",
      img_url: "",
      fields: [
        {
          label: "Username",
          name: "username",
        },
        {
          label: "Email",
          name: "email",
        },
        {
          label: "First Name",
          name: "first_name",
        },
        {
          label: "Last Name",
          name: "last_name",
        },
        {
          label: "",
          name: "img_url",
        },
      ],
      edit: false,
    };
  },
  methods: {
    selectImage() {
      this.photo = this.$refs.image.click()
    },
    imageSelected(e) {
      this.$emit('input', e.target.files[0])
      this.photo = this.$refs.image.files[0]
      this.photoName = this.photo.name
      this.url = URL.createObjectURL(this.photo)
    },
    async handleFileSubmit(){
      console.log('sending file...')
      var formData = new FormData();
      var imagefile = document.querySelector('#file');
      formData.append("image", imagefile.files[0]);
      console.log('sending to server...', formData)
      await axios.post(`${SERVER_PATH}users/upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
      }).then((response) => console.log(response))
      console.log('success')
    },
    async uploadPhoto() {
      console.log(this.photo = this.$refs.image.files[0])
      const data = new FormData()
      data.append('file', this.photo)
      data.userId = this.getUser.id
      console.log(data)
      const config = {
      headers: {
          'content-type': 'multipart/form-data'
        }
      }
      await axios({
        method: 'post',
        url: `${SERVER_PATH}users/upload`,
        data: data,
        config: config
        }).then((response) => console.log(response))
      console.log('success')
    },
    loadPhotoFromServer() {
      this.photoId = 1
     },
    avatarClick(){
      this.avatarClicked = !this.avatarClicked;
    },
    handleUpdateForm() {
      console.log(this.getUser);
      this.refreshFields();
      store.dispatch("update", this.data);
    },
    setEdit() {
      this.edit = !this.edit;
    },
    refreshFields() {
      if (this.email == "") {
        this.email = this.getUser.email;
      }
      if (this.username == "") {
        this.username = this.getUser.username;
      }
      if (this.first_name == "") {
        this.first_name = this.getUser.first_name;
      }
      if (this.last_name == "") {
        this.last_name = this.getUser.last_name;
      }
      if (this.img_url == "") {
        this.img_url = this.getUser.img_url;
      }
      if (this.email !== "") {
        this.data.email = this.email;
      }
      if (this.username !== "") {
        this.data.username = this.username;
      }
      if (this.first_name !== "") {
        this.data.first_name = this.first_name;
      }
      if (this.last_name !== "") {
        this.data.last_name = this.last_name;
      }
      if (this.img_url !== "") {
        this.data.img_url = this.img_url;
      }
    },
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  created() {
    this.data = {
      email: this.email,
      username: this.username,
      first_name: this.first_name,
      last_name: this.last_name,
      img_url: this.img_url,
    };
    console.log(this.getUser);
    console.log(this.data);
  },
};
</script>

<style scoped>
@import "../../assets/css/dashboard.css";


hr {
  border-top: 1px solid #9198aa;
}
.avatar {
  vertical-align: middle;
  width: 50px;
  height: 50px;
}
.btn {
  border: none;
}
.or {
  width: 20px;
  border-right: 1px solid #9198aa;;
}
.info-field {
  position: absolute;
  font-size: 18px;
  margin-top: 9px !important;
}
.avtr-div {
  cursor: pointer;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transform-origin: center;
  margin: auto;
  display: block;
  border-radius: 6px;
  height: 120px;
  width: 110px;
}
.avtr-div .hover-div {
  display: none;
  position: absolute;
  margin-left: -1px;
  margin-top: -1px;;
  height: 120px;
  width: 110px;
  border-radius: 6px;
}
.avtr-div:hover .hover-div {
  background-color: #191b20;
  display: block;
  opacity: 0.5;
  text-align: center;
  padding-top: 15px;
}
.avtr-div.inside {
  margin:auto !important;
  display: block;
}
.hover-div a {
  font-size: 56px;
  text-decoration: none;
  cursor: pointer;
}
.avtr-info {
  margin: 0.7rem 0 0.7rem 0;
  line-height: 0.2;
  font-size: 12px !important;
}
.avtr-btn {
  margin: 9px 0 0 0;
}
.avtr-url {
  padding-top: 5px;
  line-height: 0.2;
  margin: 0 0 0 30px;
}
.title {
  text-align: left;
  margin-left: 15px;
  margin-right: 15px;

}
.row {
  margin: 1rem 0 1rem 2rem;
}
.rt-cl {
  width: 70% !important;
}
.lt-cl {
  text-align: left;
  padding: 9px 50px 0px 50px;
}
.form-control-2 {
  color: #b2b3b4;
  background-color: #434857;
  margin-top: 5px;
  border: 1px solid #434857;
  font-size: 18px;
  border-radius: 0.25rem;
  padding: 0.375rem 0.75rem;
}
label {
  color: #b2b3b4 !important;
  font-size: 1.1rem !important;
}
.paswrd {
  font-size: 13px;
}
.edit-btn {
  text-align: center;
}
.pwd-txt {
  padding-top: 12px;
  font-size: 16px;
}
.btn-deact {
  white-space: nowrap;
  background-color: transparent;
  border: 1px solid #c7254e;
  color: #b2b3b4;
  width: 140px;
  outline: none !important;
}
.block {
  padding-top: 15px;
  padding-bottom: 18px;
  border: 1px solid #434857;
  border-radius: 5px;
}
li::marker{
  color: #1997c6;
}
.block ul{
  text-align: left;
  border: 1px solid #434857;
  margin-right: 20px;
  border-radius: 6px;
  padding: 2px;
  vertical-align: center;
}
.block ul:hover {
  background-color: #434857;
}
.block ul li {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}
.block ul li a {
  float: right !important;
  font-size: 12px !important;
  margin-top: 2px;
}
.block ul li a:hover {
  transform: scale(1.4);
}
.sub-title {
  margin-bottom: 15px;
  color: white !important;
  text-transform: capitalize;
  text-align: left;
  padding-left: 20px;
}
.popup {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  opacity: 0.99;
  text-align: center;
  background-color: #191b20;
  z-index: 1;
}
.img-popup {
  background-color: #191b20;
  margin: auto;
  margin-top: 200px;
  height: 500px;
  width: 500px;
  border: 1px solid #434857;
  padding: 15px;
}
.img-popup .exit {
  float: right; 
}
.img-popup .exit:hover {
  color: #c7254e;
  transform: scale(1.2);
  cursor: pointer;
}
.border {
  border: 1px solid #434857 !important;
  border-radius: 6px;
}
</style>